import type {QsetLogBatcher} from "@apps/qset-log-batcher";

export interface ActiveQsetLog {
  pollSlug: string;
  userId: string;
  batcher: QsetLogBatcher;
}

/**
 * Module-level registry for the qset-v4 log batcher of the qset currently on
 * stage. `usePostUserFeedback` renders outside `Poll2Page` (in the shared
 * feedback UI), so it has no prop path to the batcher instance and reaches it
 * here instead. Set by `Poll2Page` on mount/unmount.
 */
let active: ActiveQsetLog | undefined;

export const setActiveQsetLog = (value: ActiveQsetLog | undefined): void => {
  active = value;
};

export const getActiveQsetLog = (): ActiveQsetLog | undefined => active;
